export default __webpack_public_path__ + "static/media/home.390824c2.png";